"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { AfricaTownLogo } from "@/components/AfricaTownLogo";
import { SectionShell } from "./SectionShell";

/**
 * Draws the logo in, then brings the address and socials up beneath it. The
 * logo timeline used to live in the menu panel and fire on open; it belongs
 * here now, so it plays whenever Contact is selected.
 */
export function ContactSection() {
  const rootRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<SVGSVGElement>(null);

  useGSAP(
    () => {
      const logo = logoRef.current;
      if (!logo) return;

      const pinIcon = logo.querySelector(".pin-icon");
      const buildings = logo.querySelector(".buildings");
      const letters = gsap.utils.toArray(logo.querySelectorAll(".letter"));
      if (!pinIcon || !buildings || letters.length === 0) return;

      gsap.set(pinIcon, { opacity: 0, y: -50 });
      gsap.set(buildings, { clipPath: "inset(100% 0 0 0)" });
      gsap.set(letters, { opacity: 0, yPercent: 20 });

      gsap
        .timeline()
        .to(pinIcon, { opacity: 1, y: 0, duration: 1.4, ease: "power2.inOut" })
        .to(
          buildings,
          { clipPath: "inset(0% 0 0 0)", duration: 1, ease: "power2.inOut" },
          "<",
        )
        .to(
          letters,
          {
            opacity: 1,
            yPercent: 0,
            duration: 1,
            stagger: -0.03,
            ease: "power2.out",
          },
          "<",
        )
        .from(
          ".socials p",
          {
            y: 30,
            opacity: 0,
            duration: 0.8,
            stagger: 0.05,
            ease: "power3.out",
          },
          "-=0.6",
        );
    },
    { scope: rootRef },
  );

  return (
    <SectionShell>
      <div ref={rootRef}>
        <AfricaTownLogo
          ref={logoRef}
          className="w-3/4 h-auto mx-auto md:mx-0"
          iconColor="var(--color-text-on-background)"
          buildingsColor="var(--color-text-on-background)"
          textColor="var(--color-text-on-background)"
        />
        <div className="socials mx-auto w-fit md:mx-0 md:w-auto md:text-sm text-text-on-background">
          <div className="sub-col">
            <p>Central District</p>
            <p>Seattle, WA 98122</p>
            <p>United States</p>
          </div>
          <div className="sub-col">
            <p>Instagram</p>
            <p>Facebook</p>
            <p>Twitter</p>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}
